export default __webpack_public_path__ + "static/media/cradle.5a1f1956.png";